module.exports = __webpack_public_path__ + "static/media/06.9855da7a.png";